import axios from 'axios';
import store from '@/store';

const defaultOptions = {
  baseURL: process.env.API_BASE,
  method: 'get',
  headers: {
    'Content-Type': 'application/json',
  },
};
// Create instance
const instance = axios.create(defaultOptions);

instance.interceptors.request.use(async (config) => {
  await store.dispatch('inspectToken');
  const token = localStorage.getItem('token');
  config.headers['Accept-Language'] = store.getters.getAccessLanguage;

  // Frontend path where user is when calling API (pathname only).
  try {
    if (typeof window !== 'undefined' && window.location) {
      config.headers['X-Frontend-Path'] = window.location.pathname || '';
    }
  } catch (e) {
    // ignore if window is not available
  }

  // Axios 1.x: global Content-Type: application/json overrides FormData and
  if (typeof FormData !== 'undefined' && config.data instanceof FormData) {
    if (config.headers && typeof config.headers.delete === 'function') {
      config.headers.delete('Content-Type');
    } else if (config.headers) {
      delete config.headers['Content-Type'];
      delete config.headers['content-type'];
    }
  }

  if (isIEBrowser()) {
    const url = `${config.url}${config.url.includes('?') ? '&' : '?'}cb=${(new Date()).getTime()}`;
    config.url = url;
  }

  if (token) {
    config.headers.Authorization = `JWT ${token}`;
  }

  return config;
});

function isIEBrowser() {
  const ua = window.navigator.userAgent;

  if (ua.includes('MSIE') || ua.match(/Trident.*rv\:11\./)) {
    console.log('is ie');

    return true;
  }

  return false;
}

export default instance;

export function handleError(error) {
  // In some cases (network error, connection reset, CORS preflight fail, etc.),
  // Axios does not provide error.response. Guard against that to avoid runtime errors.
  const response = error && error.response ? error.response : null;
  console.log(' Api.js (30) -- ', response || error);

  if (response && (response.status === 403 || response.status === 401 || response.status === 410)) {
    store.commit('clearAuthInfo');
    window.location.href = '/login';
  }

  return response;
}
